import './lib/purchase-handoff';
import './lib/walkthrough-handoff';
import '@fontsource-variable/geist/wght.css';
import '@fontsource-variable/geist-mono/wght.css';
import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './lib/posthog';
import { startCookieConsent } from './lib/cookie-consent';
import { isEmbedDocument } from './lib/embed-document';
if (!isEmbedDocument) void startCookieConsent();
import { reportBrowserError } from './lib/browser-errors';
import { publicPageFor } from '../shared/public-pages';
import './styles.css';
import './pages/blog-page.css';

const root = document.getElementById('root')!;
const errors = {
  onUncaughtError: (error: unknown) => reportBrowserError(error, 'react_render', 'uncaught'),
  onCaughtError: (error: unknown) => reportBrowserError(error, 'react_render', 'caught'),
  onRecoverableError: (error: unknown) => reportBrowserError(error, 'react_render', 'recoverable'),
};
const snapshotPath = root.dataset.publicPage;
if (snapshotPath === window.location.pathname && publicPageFor(snapshotPath)) {
  // Keep the rendered HTML visible while this module downloads. Never replace it
  // with the application's lazy-route or session-loading fallback.
  void import('./public-document').then(({ PublicDocument }) => {
    hydrateRoot(root, <StrictMode><BrowserRouter><PublicDocument path={snapshotPath} /></BrowserRouter></StrictMode>, errors);
  });
} else {
  void import('./app').then(({ App }) => {
    createRoot(root, errors).render(<StrictMode><BrowserRouter><App /></BrowserRouter></StrictMode>);
  });
}
